.switcher {
	align-self: flex-start;
	display: flex;
	align-items: center;
	gap: var(--size-3);
	min-height: 40px;
	padding-inline: var(--size-3);
	font: inherit;
	font-weight: 700;
	color: var(--color-text);
	text-decoration: none;
	background-color: transparent;
	border: none;
	border-radius: var(--radius-md);
	transition: background-color 0.1s ease;

	button& {
		align-self: stretch;
		cursor: pointer;

		&:where(:hover, :focus-visible) {
			background-color: light-dark(var(--gray-400), var(--gray-800));
		}
	}
}

.label {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	line-height: 1;
}

.wordmark {
	font-size: var(--text-subtitle-2);
}

.section {
	font-size: 0.5rem;
	color: var(--color-text-subtle);
	text-transform: uppercase;
	letter-spacing: 0.02em;
}

/* the narrow sidebar only has room for the logo */
.label,
.arrow {
	@media (max-width: 539px) {
		display: none;
	}
}

.arrow {
	display: flex;
	margin-inline-start: auto;
	transform-origin: center center;
	transition: transform 0.1s ease;

	:has(+ :popover-open) > & {
		transform: rotate(180deg);
	}
}

.options {
	display: flex;
	flex-direction: column;
	gap: var(--size-1);
	min-width: 18rem;
	padding: var(--size-2);
}

.option {
	display: grid;
	grid-template:
		"tile label" auto
		"tile description" auto / auto 1fr;
	column-gap: var(--size-4);
	padding: var(--size-3);
	padding-inline-end: var(--size-5);
	border-radius: var(--radius-md);
	color: var(--color-text);
	text-align: left;
	text-decoration: none;
	transition: background-color 0.1s ease;

	&:where(:hover, :focus-visible) {
		background-color: light-dark(var(--gray-300), var(--gray-700));
		outline: none;
	}

	&[aria-current="page"] {
		background-color: light-dark(var(--gray-300), var(--gray-800));
		cursor: default;
	}
}

.tile {
	grid-area: tile;
	align-self: center;
	display: grid;
	place-content: center;
	width: var(--size-8);
	height: var(--size-8);
	border-radius: var(--radius-md);
	background-color: light-dark(var(--gray-400), var(--gray-700));
	color: var(--color-text-subtle);
	transition:
		background-color 0.1s ease,
		color 0.1s ease;

	:where(:hover, :focus-visible, [aria-current="page"]) > & {
		background-color: var(--color-primary);
		color: var(--gray-100);
	}
}

/* the label and description meet at the tile's midline, so the pair stays centered beside it */
.optionLabel {
	grid-area: label;
	align-self: end;
	font-weight: 600;
	line-height: 1.2;
}

.description {
	grid-area: description;
	align-self: start;
	font-size: var(--text-caption);
	line-height: 1.25;
	color: var(--color-text-subtle);
}
